import { isDev } from '../env'
export const API_BASE_URL = isDev
	? import.meta.env.VITE_API_URL
	: (import.meta.env.MODE === 'prod' ? 'https://us-central1-regresoaclasesuanl.cloudfunctions.net/api' : 'https://us-central1-asisteseguroqa.cloudfunctions.net/api')
console.log(`
    Pointing api to ${ API_BASE_URL }

`)
